export default __webpack_public_path__ + "static/media/Girdle of the Ecliptic.b55c4efc.jpg";